<template>
    <div class="history-container">
        <div class="playernames">
            <div class="playername" v-for="name, idx in playernames()" :key="idx">{{name}}</div>
        </div>
        <div class="round-container">
            <div class="rounds" v-if="!hiderounds">
                <div class="round-counter round-header">{{__('games.round')}}</div>
                <template v-if="reverse">
                    <div class="round-counter" v-for="round in generateHistory().rounds" :key="round">{{generateHistory().rounds - round + 1}}</div>
                </template>
                <div class="round-counter">-</div>
                <template v-if="!reverse">
                    <div class="round-counter" v-for="round in generateHistory().rounds" :key="round">{{round}}</div>
                </template>
            </div>
            <div :class="['history-unit', player.winner ? 'winner' : '']" v-for="player, idx in generateHistory().players" :key="idx">
                <div class="headers">
                    <div class="slot-headers">
                        <div :class="['slot-header', header.main ? 'main':'']" v-for="header in headers" :key="header.name">{{header.name}}</div>
                    </div>
                </div>
                <div class="round" v-for="row, idx2 in player.rows" :key="idx2">
                    <div :class="['slot', header.main ? 'main':'']" v-for="header in headers" :key="header.name">{{row[header.value]}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['content', 'headers', 'players', 'hiderounds'],
        data() {
            return {
                reverse: false,
            }
        },
        mounted() {
            if (window.player && window.player.roundsort == 2) {
                this.reverse = true;
            }
        },
        methods: {
            generateHistory() {
                if (!this.content) return [];
                if (this.content.custom === true) {
                    return this.generateHistoryCustom();
                }
                let players = [];
                this.players.forEach(player => {
                    players.push({id: player.id, start: this.content.start, rows: []});
                });

                let roundCounter = 0;
                players.forEach(player => {
                    roundCounter = 0;
                    player.rows.push({
                        score: player.start,
                        round: "-"
                    })
                    if (this.content && this.content.throws)
                        for (let i = 0; i < this.content.throws.length; i++) {
                            const t = this.content.throws[i];
                            if (t.player == player.id) {
                                let singlescores = '';
                                if (t.singlescores)
                                    t.singlescores.forEach(sc => {
                                        singlescores += sc.str + " ";
                                    });
                                player.rows.push({
                                    score: player.start-= t.fullscore,
                                    roundscore: t.fullscore,
                                    singlescores: singlescores,
                                    round: roundCounter+= 1
                                })
                            }
                        }
                })
                if (this.reverse) {
                    players.forEach(player => {
                        player.rows = player.rows.reverse();
                    });
                }
                return {players: players, rounds: roundCounter+1};
            },
            generateHistoryCustom() {
                return this.content;
            },
            playernames() {
                let names = [];
                this.players.forEach(player => {
                    names.push(player.name);
                });
                return names
            }
        }
    }
</script>
